import { useQuery } from '@tanstack/react-query';
import { fetchPreClaimsInitialValues } from '../data-provider/pre-claims-initial-values';

export const useGetPreClaimsInitialValues = (companyId: number) => {
  return useQuery({
    queryKey: ['pre-claims-initial-values', companyId],
    queryFn: () => fetchPreClaimsInitialValues(),
    staleTime: 1000 * 5, // 5 seconds to avoid multiple calls
    enabled: !!companyId,
  });
};
